const filter = {
  // 字符串截取
  subString(value, length) {
    if (!value) {
      return "";
    }
    value = value.trim();
    if (value.length > length) {
      var first = value.toString().substring(0, length);
      value = first + "...";
    }
    return value;
  },
  // 数字处理
  numberFormat(value) {
    value = parseInt(value);
    if (isNaN(value)) {
      return 0;
    }

    if (value >= 10000) {
      value = value + "";
      var len = value.length;
      value = value.slice(0, len - 3);
      return parseFloat(value / 10) + "万";
    } else {
      return value
    }
  },
  // 内容\n换成回车
  fmtContent(value) {
    value = value.split("\n").join("<br/>");
    return value;
  },
  //根据产品类型判断是否显示保障金额
  guaranteeLimit(content) {
    if (!content || !content.insuranceProductName) return "";
    var val = "";
    if (content.insuranceProductName.indexOf("重疾") > -1 || content.insuranceProductName.indexOf("重大疾病") > -1) {
      val = content.guaranteeLimit + "元";
    } else {
      val = "详见保障权益"
    }
    return val;
  },
  // 日期字数控制
  timeNum(content, num) {
    if (!content) return;
    if (num > content.length) return content;
    return content.substring(0, num);
  },
  // 证件类型 过滤
  identifyType(val) {
    var value = "";
    switch (val) {
      case "01":
        value = "身份证"
        break;
      case "02":
        value = "护照"
        break;
      case "03":
        value = "军官证"
        break;
      case "04":
        value = "出生证"
        break;
      case "05":
        value = "港澳台同胞证"
        break;
      case "06":
        value = "户口本"
        break;
      case "07":
        value = "港澳居民来往内地通行证"
        break;
      case "08":
        value = "港澳台通行证"
        break;
      case "09":
        value = "出生证明"
        break;
      case "99":
        value = "其它"
        break;
    }
    return value;
  },
  // 与投保人关系
  relationship(val) {
    var value = "";
    console.log(val);
    val = Number(val);
    switch (val) {
      case 1:
        value = "本人"
        break;
      case 2:
        value = "父母"
        break;
      case 3:
        value = "儿女"
        break;
      case 4:
        value = "配偶"
        break;
      case 5:
        value = "兄弟姐妹"
        break;
      case 6:
        value = "祖父母，外祖父母"
        break;
      case 7:
        value = "祖孙，外祖孙"
        break;
      case 8:
        value = "其它"
        break;
      case 9:
        value = "丈夫"
        break;
      case 10:
        value = "妻子"
        break;
      case 11:
        value = "父亲"
        break;
      case 12:
        value = "母亲"
        break;
      case 13:
        value = "儿子"
        break;
      case 14:
        value = "女儿"
        break;
    }
    return value;
  },
  /*内容\n换成回车*/
  fmtContent(typeCode) {
    if (!typeCode) return;
    var html = "";
    typeCode = typeCode.split("\n");
    for (var k in typeCode) {
      if (k < 3) {
        var text = typeCode[k].substring(0, 15);
        html += '<p><i class="iconfont icon-dianzan3 margin-right-10"></i>' + text + '</p>';
      }
    }
    return html;
  },
  //保单状态
  policyStatus(value) {
    if (!value) return
    if (value == "1" || value == "2") {
      return "保障中"
    } else if (value == "3") {
      return "已退保"
    } else {
      return "已失效"
    }
  },
  payProice (value) {
    if(!value)return
    if(value.split(".")[1] >0){
        return value
    }else{
        return value.split(".")[0]
    }
  },
  // settleType(value){
  //   if (value == 4) {
  //       return "已完成";
  //   } else if (value == 0) {
  //       Data[i].settleStatus = "受理中";
  //       Data1.push(Data[i])
  //   } else if (Data[i].settleStatus == 1) {
  //       Data[i].settleStatus = "审核中";
  //       Data1.push(Data[i])
  //   } else if (Data[i].settleStatus == 2) {
  //       Data[i].settleStatus = "审核通过";
  //       Data1.push(Data[i])
  //   } else if (Data[i].settleStatus == 3) {
  //       Data[i].settleStatus = "打款中";
  //       Data1.push(Data[i])
  //   }
  // }
}









export {
  filter
}



// WEBPACK FOOTER //
// ./src/api/filter.js